export enum DIKeyEnum {
    CONFIG = "CONFIG",
}
